export default __webpack_public_path__ + "static/media/moon.c7ec4728.svg";